import {Box, Grid, Tooltip} from '@mui/material';
import {AppIconButton} from 'components/buttons';
import {AppControlledInput, AppStatusSelect} from 'components/form';
import {AppPopover} from 'components/menus';
import {useCreateItemDataAPI, useTableBoardData} from 'hooks';
import {Add} from 'iconsax-react';
import {ItemDataFieldModel} from 'models/board';
import {useEffect} from 'react';
import {useForm} from 'react-hook-form';
import {useParams} from 'react-router-dom';

interface AddNewItem {
    title: string;
    itemStatusId: string;
}
interface TableBoardViewAddNewItemProps {
    selectedFeild: ItemDataFieldModel;
    refreshTableData: () => void;
}
export const TableBoardViewAddNewItem: React.FC<TableBoardViewAddNewItemProps> = ({
    selectedFeild,
    refreshTableData,
}) => {
    const {createItemData, createItemDataLaoding, createItemDataResponse} = useCreateItemDataAPI();
    const {getNewlyCreatedItemWithTitleSetToTheFirstField} = useTableBoardData();
    const {handleSubmit, control, reset} = useForm<AddNewItem>({
        defaultValues: {title: '', itemStatusId: ''},
    });
    const {boardId} = useParams();

    const onAddITemSubmitHandler = (value: AddNewItem) => {
        const request = getNewlyCreatedItemWithTitleSetToTheFirstField(value.title, value.itemStatusId);
        if (request) {
            createItemData({
                variables: {
                    input: request,
                },
            });
        }
    };
    useEffect(() => {
        if (createItemDataResponse && !createItemDataLaoding) {
            refreshTableData();
            reset({title: '', itemStatusId: ''});
        }
    }, [createItemDataResponse, createItemDataLaoding]);

    return (
        <>
            <AppPopover
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                renderElement={(handleOpen, open) => (
                    <Box ml={1}>
                        <AppIconButton onClick={handleOpen} size="small">
                            <Tooltip title="Add New Item">
                                <Add />
                            </Tooltip>
                        </AppIconButton>
                    </Box>
                )}
                renderChildren={(handleOpen, open) => (
                    <Box mb={1} component={'form'} onSubmit={handleSubmit(onAddITemSubmitHandler)} width={'100%'}>
                        <Box sx={{p: 1, py: 2, transition: 'background-color 0.25s ease-out'}}>
                            <Grid
                                spacing={1}
                                container
                                alignItems="center"
                                position={'relative'}
                                justifyContent={'flex-end'}
                            >
                                <Grid item style={{position: 'absolute', top: -10, right: 0}}>
                                    <AppIconButton isLoading={createItemDataLaoding} type="submit" size="small">
                                        <Add />
                                    </AppIconButton>
                                </Grid>
                                <Grid item xs={12}>
                                    <AppControlledInput
                                        required
                                        fullWidth
                                        placeholder="Add Item"
                                        control={control}
                                        name="title"
                                        label={selectedFeild.title}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <AppStatusSelect
                                        shouldReturnValueOnly
                                        boardSlug={boardId || ''}
                                        required
                                        fullWidth
                                        disableClearable
                                        control={control}
                                        name="itemStatusId"
                                        label={'States'}
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                )}
            />
        </>
    );
};

export default TableBoardViewAddNewItem;
